import { Emitter } from "project-config/services/emitter";
import { RequestResponse } from "project-config/services/request/types";
import { AxiosResponse } from "axios";
import { ConnectStatus } from "project-config/constants";

export class NotifyCenter {
  static axiosResponseInterceptor = new Emitter<
    AxiosResponse<RequestResponse<any>>
  >();
  static raysyncConnectStatus = new Emitter<ConnectStatus>();
}
